import { render } from "./CorrosivityZone.vue?vue&type=template&id=36ca73b5"
import script from "./CorrosivityZone.vue?vue&type=script&lang=js"
export * from "./CorrosivityZone.vue?vue&type=script&lang=js"

import "./CorrosivityZone.vue?vue&type=style&index=0&id=36ca73b5&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__